<template>
  <div id="spanish">
    <Header :data="myJson.header"/>
    <Home :data="myJson.home"/>
      <About :data="myJson.about"/>
         <Banner2 :data="myJson.banner2"/>
       <!--  <Team/> este no va -->
     <Services :data="myJson.services"/>
    
      <Statistic :data="myJson.statistic"/>
    <!--  <Banner2 :data="myJson.banner2"/> -->
     
    
         <Portafolio :data="myJson.portafolio"/>               
       <Banner :data="myJson.banner"/> 
     <Article :data="myJson.article"/>
 <!--  <Blog msg="Welcome to Your Vue.js App"/> -->
 <!--  <Tweets msg="Welcome to Your Vue.js App"/> -->
 <!--  <Clients msg="Welcome to Your Vue.js App"/> -->
  <Contact :data="myJson.contact"/>
   <Footer :data="myJson.footer"/>
  </div>
</template>

<script>
import Header from '../components/Header.vue';
import Home from '../components/Home.vue';
import About from '../components/About.vue';
import Statistic from '../components/Statistic.vue';
// import Team from './components/Team.vue';
import Portafolio from '../components/Portafolio.vue';
import Article from '../components/Article.vue';
import Banner from '../components/Banner.vue';
import Banner2 from '../components/Banner2.vue';
import Services from '../components/Services.vue';
// import Blog from './components/Blog.vue';
// import Tweets from './components/Tweets.vue';
// import Testimonial from './components/Testimonial.vue';
// import Clients from './components/Clients.vue';
import Contact from '../components/Contact.vue';
import Footer from '../components/Footer.vue';
import json from '../assets/data_en.json'
export default {
  name: 'Spanish',
  components: {
    Header,
    Home,
    About,
    // Team,
    Statistic,
    Portafolio,
    Article,
    Banner,
    Banner2,
    Services,
    // Blog,
    // Tweets,
    // Testimonial,
    // Clients,
    Contact,
    Footer
  },  data(){
    return{
      myJson: json
    }
  },
}


</script>

<style>

</style>
